import { jsx as C } from "react/jsx-runtime";
import { c as o, e as m, f as B, r as v, s as d } from "../instance-B0lHmJzq.js";
import { createContext as x, useState as f, useEffect as p, useContext as g } from "react";
const r = x({
  get: () => {
  },
  set: () => {
  },
  remove: () => {
  }
}), b = () => {
  const t = g(r);
  if (!t)
    throw new Error(
      "useDataBaseContext must be used within a DataBaseProvider"
    );
  return t;
}, h = ({
  children: t
}) => {
  const [s, n] = f(o()), a = (e, u, D) => {
    d(e, u, D), n(o());
  }, c = (e) => {
    v(e), n(o());
  }, i = (e) => s[e];
  return p(() => {
    const e = () => {
      n({ ...o() });
    };
    return m(e), () => {
      B(e);
    };
  }, []), /* @__PURE__ */ C(r.Provider, { value: { get: i, set: a, remove: c }, children: t });
};
export {
  h as DuckDBConnectionProvider,
  b as useDuckDBConnectionContext
};
